export enum HeapIdentifiers {
  CONFIRM_URL = '11confirm11',
  CREATE_FLOWCODE = '11create11',
  DOWNLOAD_FLOWCODE = '11download11',
  DUPLICATE_FLOWCODE = '11duplicate11',
  EDIT_FLOWCODE = '11edit11',
  SHARE_FLOWCODE = '11share11',
  CREATE_ACCOUNT = '11account11'
}

export enum HeapContainers {
  CREATE_FLOWCODE = 'creation_flow',
  CREATE_FLOWCODE_BULK = 'creation_flow_bulk',
  CREATE_FLOWCODE_WITH_FLOWPAGE = 'combined_flow',
  DOWNLOAD_FLOWCODE = 'download_flowcode',
  EDIT_FLOWCODE_DESIGN = 'edit_flowcode_design',
  FLOWCODE_DETAILS = 'flowcode_details',
  DELETE_FLOWCODE_MODAL = 'delete_code_modal',
  DOWNLOAD_FLOWCODE_MODAL = 'download_code_modal',
  DUPLICATE_FLOWCODE_MODAL = 'duplicate_code_modal',
  TRANSFER_FLOWCODE_MODAL = 'transfer_code_modal',
  EMAIL_FLOWCODE_MODAL = 'email_code_modal',
  PERMISSIONS_FLOWCODE_MODAL = 'permissions_code_modal',
  AUTH_FORM = 'auth_form',
  UPGRADE = 'upgrade',
  USE_CASES = 'applications',
  NAVIGATION = 'nav',
  LANDING_PAGE = 'landing_page',
  SELECT_PLAN_TILES = 'select_plan_tiles',
  CODE_MANAGEMENT = 'code_management',
  SIDEBAR = 'sidebar',
  POST_DOWNLOAD = 'post_download',
  RESOURCES = 'resources',
  FLOWLYTICS = 'flowlytics'
}

// TODO: create a utility function to generate heap IDs
